import React from 'react';

import { useSetAtom } from 'jotai';

import { toastAtom } from '@smart-tv/atoms';

export interface UseToastValues {
  showToast: (message: string, iconType: IconTypes) => void;
}

export enum IconTypes {
  success = 'success',
  failure = 'failure',
  info = 'info'
}

export const useToast = (): UseToastValues => {
  const setToast = useSetAtom(toastAtom);

  const showToast = React.useCallback(
    (message: string, iconType: IconTypes) => {
      setToast({ message, iconType });
    },
    [setToast]
  );

  return { showToast };
};

export default useToast;
